<div class="chart-header">Other CAPEX ($MM)</div>

<div class="scrollable-chart-wrapper">
  <app-scrollable-chart [chartData]="chartData" [chartParams]="chartParams"
    [timeFrameMode]="timeFrameMode"></app-scrollable-chart>
</div>
